import { Tooltip } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import PuxIconBuilder from 'Shared/components/PuxIconBuilder/PuxIconBuilder'
import { t } from 'ttag'

const TrialFormKR: FunctionComponent = () => {
  return (
    <div id='mauticform_wrapper_trialrequest' className='mauticform_wrapper'>
      <form
        autoComplete='false'
        role='form'
        method='post'
        action='https://mautic2018.easyredmine.com/form/submit?formId=4'
        id='mauticform_trialrequest'
        data-mautic-form='trialrequest'
        encType='multipart/form-data'
      >
        <div className='mauticform-error' id='mauticform_trialrequest_error' />
        <div
          className='mauticform-message'
          id='mauticform_trialrequest_message'
        />
        <div className='mauticform-innerform'>
          <div style={{ display: `none` }} className='mautictrial-form-select'>
            <label className='radio radio-container selected'>
              <input
                type='radio'
                name='mauticform[forced_project_id]'
                id='mauticform_input_trialrequest_forced_project_id_2'
                value='0'
                defaultChecked={true}
              />
              <Tooltip
                title={
                  <>
                    <h4>Full demo</h4>
                    <ul>
                      <li>모든 기능이 포함 된 full demo</li>
                      <li>
                        4 가지의 관리자 역할 내 사전 정의 된 15가지의 사용자
                        역할 선택 가능
                      </li>
                      <li>
                        기능 모두 포함{` `}
                        <strong>Easy Redmine Platform</strong>
                      </li>
                    </ul>
                  </>
                }
                placement='top'
              >
                <span>
                  {` `}
                  <strong>Full demo</strong> 자세한 기능 설명에 대하여
                  {` `}
                  <PuxIconBuilder icon='InfoIcon' />
                </span>
              </Tooltip>
            </label>
            <label className='radio radio-container'>
              <input
                type='radio'
                name='mauticform[forced_project_id]'
                id='mauticform_input_trialrequest_forced_project_id_1'
                value='1'
                defaultChecked={false}
              />
              <Tooltip
                title={
                  <>
                    <h4>Lite demo</h4>
                    <ul>
                      <li>Demo 데이터 포함 되지 않음</li>
                      <li>
                        사전 정의된 2가지 사용자 역할 선택-프로젝트 관리자, 팀
                        구성원
                      </li>
                      <li>
                        기능 포함 {` `}
                        <strong>Easy Redmine Business</strong>
                      </li>
                    </ul>
                  </>
                }
                placement='top'
              >
                <span>
                  {` `}
                  <strong>Lite demo</strong> 빠르고 쉬운 처리에 대하여
                  {` `}
                  <PuxIconBuilder icon='InfoIcon' />
                </span>
              </Tooltip>
            </label>
          </div>
          <div
            className='mauticform-page-wrapper mauticform-page-1'
            data-mautic-form-page={1}
          >
            <div
              id='mauticform_trialrequest_email'
              data-validate='email'
              data-validation-type='email'
              className='mauticform-row mauticform-email mauticform-field-1 mauticform-required'
            >
              <label
                id='mauticform_label_trialrequest_email'
                htmlFor='mauticform_input_trialrequest_email'
                className='mauticform-label'
              >
                {t`Redmine.TrialCTAForm.Email`}
              </label>
              <input
                id='mauticform_input_trialrequest_email'
                name='mauticform[email]'
                className='mauticform-input'
                type='email'
                placeholder={t`Redmine.TrialCTAForm.YourEmail`}
              />
              <span className='mauticform-errormsg' style={{ display: `none` }}>
                {t`Redmine.TrialCTAForm.Required`}
              </span>
            </div>
            <input
              id='mauticform_input_trialrequest_first_name'
              name='mauticform[first_name]'
              className='mauticform-hidden'
              type='hidden'
            />
            <input
              id='mauticform_input_trialrequest_last_name'
              name='mauticform[last_name]'
              className='mauticform-hidden'
              type='hidden'
            />
            <input
              id='mauticform_input_trialrequest_affiliate_account_id'
              name='mauticform[affiliate_account_id]'
              className='mauticform-hidden'
              type='hidden'
            />
            <input
              id='mauticform_input_trialrequest_affiliate_conversion_id'
              name='mauticform[affiliate_conversion_id]'
              className='mauticform-hidden'
              type='hidden'
            />
            <input
              id='mauticform_input_trialrequest_submission_form_identifier'
              name='mauticform[submission_form_identifier]'
              defaultValue='www.easyredmine.com;demo;'
              className='mauticform-hidden'
              type='hidden'
            />
            <input
              id='mauticform_input_trialrequest_identifier'
              name='mauticform[identifier]'
              className='mauticform-hidden'
              type='hidden'
            />
            <input
              id='mauticform_input_trialrequest_source'
              name='mauticform[source]'
              defaultValue='trial'
              className='mauticform-hidden'
              type='hidden'
            />
            <div
              id='mauticform_trialrequest_recaptcha'
              className='mauticform-row mauticform-div-wrapper mauticform-field-10'
            >
              <label
                id='mauticform_label_trialrequest_recaptcha'
                htmlFor='mauticform_input_trialrequest_recaptcha'
                className='mauticform-label'
              >
                reCaptcha
              </label>
              <input
                id='mauticform_input_trialrequest_recaptcha'
                name='mauticform[recaptcha]'
                className='mauticform-input'
                type='hidden'
              />
              <span
                className='mauticform-errormsg'
                style={{ display: `none` }}
              />
            </div>
            <div
              id='mauticform_trialrequest_submit'
              className='mauticform-row mauticform-button-wrapper mauticform-field-11'
            >
              <button
                type='submit'
                name='mauticform[submit]'
                id='mauticform_input_trialrequest_submit'
                className='mauticform-button btn btn-default'
              >
                {t`Redmine.TrialCTAForm.Submit`}
              </button>
            </div>
          </div>
        </div>
        <input
          type='hidden'
          name='mauticform[formId]'
          id='mauticform_trialrequest_id'
          defaultValue={4}
        />
        <input
          type='hidden'
          name='mauticform[return]'
          id='mauticform_trialrequest_return'
        />
        <input
          type='hidden'
          name='mauticform[formName]'
          id='mauticform_trialrequest_name'
          defaultValue='trialrequest'
        />
      </form>
    </div>
  )
}

export default TrialFormKR
